import React from "react";
import { connect } from "react-redux";
import { CssBaseline,Typography, Box, Container,TextField, withStyles} from "@material-ui/core";
import { Helmet } from "react-helmet";
import { AppointmentActions } from "../../redux/actions/AppointmentActions";
import { PatientActions } from "../../redux/actions/PatientActions";
import SearchDoctorList from '../doctor/search/SearchDoctorList';
import BookNewAppointmentInput from './BookNewAppointmentInput'
import Autocomplete from "@material-ui/lab/Autocomplete";
import { history } from "../../components/helpers/History";

const useStyles = (theme) => ({
  main: {
    marginTop : theme.spacing(4),
  }
});

class DoctorSearchList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      patientId : this.props.patientId,
      submitted : false,
      doctorId : '',
      consultationType: "",
      startDateTime: "",
      description: "",
      hideDoctorSearch : false,
      isAppointmentBooked : false,
      showPatient : false,
      disableDoctorSelection : false
    }
  }
  
  componentDidMount() {
    if(this.props.patientId && this.props.patientId.length > 0){
        this.setState({patientId:this.props.patientId});
    }else if(this.props.user && this.props.user.userRole==="ROLE_PATIENT"){
      this.setState({patientId:this.props.user.patientId});
    }else{
      this.props.getAllPatients();
      this.setState({showPatient:true});
    }
  }

  handleSearchDoctor = (payload) => {
    this.setState({
        doctorId:payload.doctorId,
        hideDoctorSearch:true,
        startDateTime:payload.startDateTime,
        disableDoctorSelection:true
      });
  };
  
  componentDidUpdate(prevProps){
    if(this.props.isAppointmentUpdated && !this.state.isAppointmentBooked){
      this.setState({isAppointmentBooked:true});
      this.props.clearAll();
      if(this.props.handleBookNewAppointSuccess){
        this.props.handleBookNewAppointSuccess();
      }else{
        history.goBack();
      }
      

    }
  }

  handleAppointment = (values) => {
      const bookAppointment = {
        consultationType: values.consultationType,
        startDateTime: values.startDateTime,
        description: values.description,
        doctorId : this.state.doctorId,
        patientId : this.state.patientId,
        status : values.status
      }
      console.log(JSON.stringify(bookAppointment));
      this.setState({bookAppointment});
      this.props.bookAppointment(bookAppointment);
      
  }

  handleBack = () =>{
    this.setState({
      hideDoctorSearch:false,
      disableDoctorSelection:false
    });
  }

 


  render() {
    const classes = this.props.classes;
    return (
      <Container maxWidth={false} className={classes.main}>
        <Helmet>
          <title>RxRapidMad | Book new appointment</title>
        </Helmet>
        <CssBaseline />
        <Box style={{
            backgroundColor: 'background.default',
          }}
        >
         
        <Typography gutterBottom variant="h4" color="primary">Book appointment</Typography>

        {this.state.showPatient ?
         <Box
         style={{
           backgroundColor: "background.default",
           marginTop : 20
         }}
       >
        <Autocomplete
                        freeSolo
                        id="free-solo-2-demo"
                        disableClearable
                        disabled = {this.state.disableDoctorSelection}
                        options={this.props.patientList.map((option) => option)}
                        getOptionLabel={(option) => {
                          return ((option.firstName ? option.firstName :"")+" "+(option.lastName ? option.lastName:""))}
                        }
                        onChange={(event,nextValue)=> {
                          this.setState({patientId:nextValue.id})
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Patient Name"
                            variant="outlined"
                            id="patinetId"
                            name="patinetId"
                            value={this.state.patinetId}
                            InputProps={{
                              ...params.InputProps,
                              type: "search",
                            }}
                          />
                        )}
                      />
        </Box>
        : null}

        {this.state.hideDoctorSearch? 
            <BookNewAppointmentInput
             handleAppointment = {(values) => {this.handleAppointment(values)}}
             doctorId = {this.state.doctorId}
             startDateTime ={this.state.startDateTime}
             handleBack = {()=>{this.handleBack()}}
             ></BookNewAppointmentInput>
        :
        this.state.patientId && this.state.patientId.length > 0 ?
          <SearchDoctorList handleBookAppointment={(payload)=>{this.handleSearchDoctor(payload)}}
          startDateTime ={this.state.startDateTime}
          ></SearchDoctorList>
          :
          null

        }
      </Box>
    </Container>
    );
  }
}

function mapStateToProps(state) {
  const  user  = state.authentication.user;
  const isAppointmentUpdated = state.appointment.isAppointmentUpdated;
  const patientList = state.patient.all;
  return { user , isAppointmentUpdated,patientList};
}

const mapDispatchToProps  = (dispatch) =>  {
  return {
    bookAppointment: (values) => {
      dispatch(AppointmentActions.bookAppointment(values));
    },clearAll : () => {
      dispatch(AppointmentActions.clearAll());
    },getAllPatients: () => {
      dispatch(PatientActions.getActiveAllPatients());
    }
  }
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles, { withTheme: true })(DoctorSearchList));

